require('./footable.min');
jQuery(function($){
	$('.table').footable();
    });